import config from "../../config"

export function loadFacebookSDK() {
	window.fbAsyncInit = function() {
		window.FB.init({
			appId: config.auth.social.FB,
			autoLogAppEvents: true,
			xfbml: true,
			version: "v4.0"
		})
	}
	;(function(d, s, id) {
		var js,
			fjs = d.getElementsByTagName(s)[0]
		if (d.getElementById(id)) {
			return
		}
		js = d.createElement(s)
		js.id = id
		js.src = "https://connect.facebook.net/en_US/sdk.js"
		fjs.parentNode.insertBefore(js, fjs)
	})(document, "script", "facebook-jssdk")
}

export const sizeofwindows = size => {
	if (size === "sm") return window.innerWidth <= 760
	else if (size === "smm") return window.innerWidth === 768
	else if (size === "smd") return window.innerWidth <= 768
	else if (size === "tb")
		return window.innerWidth > 768 && window.innerWidth < 1199
	else if (size === "md") return window.innerWidth <= 1024
	else if (size === "lg") return window.innerWidth > 1919
}
